import Banner from 'app/components/partials/banner';
import ContentBlocks from 'app/components/content-blocks/index';
import FilterStories from 'app/components/partials/filter-stories.container';
import { LAYOUT } from 'app/utilities/news-listing';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

/**
 * `/news-archive`: every published article, the oldest reachable by paging
 * rather than through a category.
 *
 * An ordinary CMS page as far as its banner, its blocks and its SEO fields go;
 * what it holds between them is fixed here rather than assembled from blocks,
 * because the listing is the point of the page.
 */
class NewsArchive extends Component {
    render() {
        const {
            blocks,
            name: title,
            highlighted_information: highlight,
            main_images: images,
            short_description: description
        } = this.props.data;

        return (
            <div className="page || news-view">
                <Banner
                    title={title}
                    introduction={description}
                    highlight={highlight}
                    images={images} />
                {/* No categories to tick, so the rows are all cards: nine to a
                    page, three to a row, one page at a time. The listing runs to
                    hundreds of pages, so each is served as the slice it names
                    rather than as everything up to it. */}
                <FilterStories
                    layout={LAYOUT.PAGED}
                    listingPage={this.props.listingPage} />
                <ContentBlocks data={blocks} hasListing={true} />
            </div>
        );
    }
}

NewsArchive.propTypes = {
    data: PropTypes.object.isRequired,
    listingPage: PropTypes.number
};

export default NewsArchive;
